import { AlertTriangle, Loader2, Trash2 } from "lucide-react";
import { CertificationButton } from "./CertificationButton";
import { CertificationModal } from "./CertificationModal";

type Props = {
  open: boolean;
  title: string;
  description: string;
  confirming?: boolean;
  confirmLabel?: string;
  onClose: () => void;
  onConfirm: () => void;
  eyebrow?: string;
};

export function CertificationConfirmDialog({
  open,
  title,
  description,
  confirming = false,
  confirmLabel = "Eliminar",
  onClose,
  onConfirm,
  eyebrow = "Confirmación",
}: Props) {
  return (
    <CertificationModal
      open={open}
      title={title}
      eyebrow={eyebrow}
      description="Esta acción requiere confirmación."
      onClose={onClose}
      submitting={confirming}
      closeOnBackdrop={false}
      footer={
        <>
          <CertificationButton variant="secondary" onClick={onClose} disabled={confirming}>
            Cancelar
          </CertificationButton>
          <CertificationButton
            variant="danger"
            icon={confirming ? <Loader2 size={16} className="animate-spin" /> : <Trash2 size={16} />}
            onClick={onConfirm}
            disabled={confirming}
          >
            {confirming ? "Eliminando..." : confirmLabel}
          </CertificationButton>
        </>
      }
    >
      <div className="iso27001-confirm-content">
        <span className="iso27001-confirm-icon"><AlertTriangle size={22} /></span>
        <p>{description}</p>
      </div>
    </CertificationModal>
  );
}
